import { useAppSelector } from 'src/redux/hooks';

import { industryStandardsSelectorData } from './selectors';

export const useIndustryStandards = () => useAppSelector(industryStandardsSelectorData);
